export default __webpack_public_path__ + "assets/spaceflight.ae321722.png";